// extracted by mini-css-extract-plugin
module.exports = {"openSimulator":"OpenSimulator_openSimulator__Xunp_","indicator":"OpenSimulator_indicator__3PdOR","button":"OpenSimulator_button__3UoAu"};